module.exports = __webpack_public_path__ + "img/gm.84b484d4.svg";